import axios from 'axios';

const CurrentCountry = () => axios.get('https://ipinfo.io/json')
  .then((response) => response.data.country)
  .catch((error) => { console.error(error.message); });

export default CurrentCountry;



// WEBPACK FOOTER //
// ./src/services/CurrentCountry.js